import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/apps/viewup/app/global-error.tsx");
